module.exports = __webpack_public_path__ + "static/media/icon_stop.29350abf.png";